import { Typography } from "@mui/material";
import { MessageBubble, MessageContainer } from "./ChatMessage.styled";

interface UserMessageProps {
  question: string;
}

export function UserMessage({ question }: UserMessageProps) {
  return (
    <MessageContainer isUser>
      <MessageBubble isUser>
        <Typography variant="body1" sx={{ lineHeight: 1.6, fontWeight: 500, color: "#FFFFFF !important" }}>
          {question}
        </Typography>
      </MessageBubble>
    </MessageContainer>
  );
}
